import * as m from './model';

export const initialState: m.IState = {
    locationStatus: {
        assignedTicket: null
    },
    queues: [],
    services: []
};

export const reducer = (state: m.IState, action: m.ActionTypes): m.IState => {
    switch (action.type) {
        case m.LOAD_LOCATION_STATUS:
            return { ...state, locationStatus: action.payload };
        case m.LOAD_QUEUES:
            return { ...state, queues: action.payload };
        case m.REPLACE_QUEUE:
            return { ...state, queues: state.queues.map(x => {
                if (x.id == action.payload.id) {
                    if (!x.isSelectedInLocation) {
                        x.isSelectedInLocation = true;
                        x.tickets = action.payload.tickets;
                        return x;
                    } else {
                        x.isSelectedInLocation = false;
                        return x;
                    }
                } else {
                    return x;
                }
            }) };
        case m.LOAD_SERVICES:
            return { ...state, services: action.payload };
        case m.UPDATE_SERVICE: {
            return {
                ...state,
                services: state.services.map(x => {
                    if (x.id === action.payload.id) {
                        x.count = action.payload.count;
                    }
                    return x;
                })
            };
        }
        case m.REMOVE_ASSIGNED_TICKET:
            return {
                ...state,
                locationStatus: {
                    ...state.locationStatus,
                    assignedTicket: action.payload.ticketId == null ? 
                    null : 
                    (state.locationStatus.assignedTicket?.id == action.payload.ticketId ? null : state.locationStatus.assignedTicket)
                }
            };
        case m.ADD_TICKET:
            const ticket = action.payload.ticket;
            let tickets: m.ITicket[] = [];
            return {
                ...state,
                queues: state.queues.map(x => {
                    if (x.id === ticket.queueId && !tickets.find(x => x.id === ticket.id)) 
                    {
                        x.tickets = x.tickets.filter(x => x.id !== ticket.id);
                        x.tickets = [...x.tickets, ticket];
                        tickets = [...tickets, ticket];
                    }
                    else if(action.payload.isRemoveNeeded)
                    {
                        x.tickets = x.tickets.filter(x => x.id !== ticket.id);
                    }

                    return x;
                })
            };
        case m.REMOVE_TICKET_FROM_QUEUE:
            return {
                ...state,
                queues: state.queues.map(x => {
                        x.tickets = x.tickets.filter(x => x.id !== action.payload.ticketId);
                    return x;
                })
            };
        case m.ASSIGN_TICKET:
            if(action.payload.ticket?.invitingTicketLocationId === action.payload.locationId)
            {
                return {
                    ...state,
                    locationStatus: {
                        ...state.locationStatus,
                        assignedTicket: action.payload.ticket
                    }
                }
            }
            else{
                return state;
            };
           
        case m.UPDATE_TICKET_STATE:
            return {
                ...state,
                queues: state.queues.map(x => {
                    x.tickets.forEach(ticket => {
                        if(ticket.id === action.payload.ticketId)
                        {
                            ticket.state = action.payload.newState;
                        }
                        
                    });
                    return x;
                })
            };

        case m.UPDATE_TICKET_STATE_OR_ADD_TO_QUEUE:
            const currTicket = action.payload.ticket;
            let existingTickets: m.ITicket[] = [];
            return {
                ...state,
                queues: state.queues.map(x => {
                    if (x.id === action.payload.ticket.queueId && !existingTickets.find(x => x.id === action.payload.ticket.id)) 
                    {
                        x.tickets = x.tickets.filter(x => x.id !== currTicket.id);
                        currTicket.state = action.payload.newState;
                        x.tickets = [...x.tickets, currTicket];
                        existingTickets = [...existingTickets, currTicket];
                    }

                    return x;
                })
            };
        default:
            return state;
    }
};
